import React, { useState } from 'react';

const RandomSwitching = () => {
  const [searchTerm, setSearchTerm] = useState('');
  
  const [switchingData, setSwitchingData] = useState([
    {
      id: 1,
      ruleName: 'Random Rule 1',
      operator: 'Airtel',
      apiProviders: ['API Provider 1', 'API Provider 2', 'API Provider 3'],
      percentage: 'Equal Distribution',
      totalTransactions: 1500,
      status: 'Active',
      lastUpdated: '2025-11-05 10:30 AM'
    },
    {
      id: 2,
      ruleName: 'Random Rule 2',
      operator: 'Vodafone',
      apiProviders: ['API Provider 2', 'API Provider 4'],
      percentage: '60:40',
      totalTransactions: 890,
      status: 'Active',
      lastUpdated: '2025-11-05 09:15 AM'
    },
    {
      id: 3,
      ruleName: 'Random Rule 3',
      operator: 'Jio',
      apiProviders: ['API Provider 1', 'API Provider 3', 'API Provider 5'],
      percentage: '50:30:20',
      totalTransactions: 2100,
      status: 'Active',
      lastUpdated: '2025-11-05 08:45 AM'
    },
    {
      id: 4,
      ruleName: 'Random Rule 4',
      operator: 'BSNL',
      apiProviders: ['API Provider 2'],
      percentage: '100',
      totalTransactions: 450,
      status: 'Inactive',
      lastUpdated: '2025-11-04 05:20 PM'
    }
  ]);

  const filteredData = switchingData.filter(item => {
    const matchesSearch = 
      item.ruleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.operator.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesSearch;
  });

  const handleStatusToggle = (id) => {
    setSwitchingData(switchingData.map(item => 
      item.id === id 
        ? { ...item, status: item.status === 'Active' ? 'Inactive' : 'Active' }
        : item
    ));
  };

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1">Random Switching</h2>
          <p className="text-muted mb-0">Manage random distribution of transactions across API providers</p>
        </div>
        <button className="btn btn-primary">
          <i className="bi bi-plus-circle me-2"></i>
          Add Random Rule
        </button>
      </div>

      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-12">
              <label className="form-label">Search</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by rule name or operator..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Rules</h6>
                  <h3 className="mb-0">{switchingData.length}</h3>
                </div>
                <i className="bi bi-shuffle fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-success text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Active Rules</h6>
                  <h3 className="mb-0">
                    {switchingData.filter(item => item.status === 'Active').length}
                  </h3>
                </div>
                <i className="bi bi-check-circle-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-info text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Transactions</h6>
                  <h3 className="mb-0">
                    {switchingData.reduce((sum, item) => sum + item.totalTransactions, 0)}
                  </h3>
                </div>
                <i className="bi bi-graph-up fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-warning text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Avg Distribution</h6>
                  <h3 className="mb-0">Equal</h3>
                </div>
                <i className="bi bi-pie-chart-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-light">
                <tr>
                  <th>Rule Name</th>
                  <th>Operator</th>
                  <th>API Providers</th>
                  <th>Distribution %</th>
                  <th>Transactions</th>
                  <th>Status</th>
                  <th>Last Updated</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <i className="bi bi-shuffle text-primary me-2"></i>
                        <strong>{item.ruleName}</strong>
                      </td>
                      <td>{item.operator}</td>
                      <td>
                        <div className="d-flex flex-wrap gap-1">
                          {item.apiProviders.map((provider, idx) => (
                            <span key={idx} className="badge bg-secondary">
                              {provider}
                            </span>
                          ))}
                        </div>
                      </td>
                      <td>
                        <span className="badge bg-info">{item.percentage}</span>
                      </td>
                      <td>
                        <span className="badge bg-primary">{item.totalTransactions}</span>
                      </td>
                      <td>
                        <span className={`badge ${
                          item.status === 'Active' ? 'bg-success' : 'bg-danger'
                        }`}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <small className="text-muted">{item.lastUpdated}</small>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm" role="group">
                          <button className="btn btn-outline-primary" title="Edit">
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button 
                            className={`btn ${
                              item.status === 'Active' ? 'btn-outline-danger' : 'btn-outline-success'
                            }`}
                            onClick={() => handleStatusToggle(item.id)}
                            title={item.status === 'Active' ? 'Deactivate' : 'Activate'}
                          >
                            <i className={`bi ${
                              item.status === 'Active' ? 'bi-toggle-on' : 'bi-toggle-off'
                            }`}></i>
                          </button>
                          <button className="btn btn-outline-danger" title="Delete">
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-5">
                      <i className="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                      <p className="text-muted mb-0">No random rules found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted">
              Showing {filteredData.length} of {switchingData.length} rules
            </div>
            <div>
              <button className="btn btn-sm btn-outline-primary me-2">
                <i className="bi bi-download me-1"></i>
                Export
              </button>
              <button className="btn btn-sm btn-outline-secondary">
                <i className="bi bi-arrow-clockwise me-1"></i>
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RandomSwitching;

